import { EnzymeVault } from '../../model';
import { Type } from 'class-transformer';
import { Address } from '@31third/common';
import { Chain } from 'common';

export class EnzymeState {
  connectedSigner: Address | undefined;
  chain: Chain | undefined;

  @Type(() => EnzymeVault)
  vaults: EnzymeVault[]; // vaults without allocation assets
  vaultsLoaded: boolean;

  @Type(() => EnzymeVault)
  selectedVault: EnzymeVault | undefined; // vault with allocation assets

  useOwnerInsteadOfConnectedWallet: boolean;

  isTaurus: boolean;
}
